module.exports = __webpack_public_path__ + "static/media/connection3.bee58c44.svg";